import { isPlatformBrowser } from '@angular/common';
import { ConfigService } from '../config/config.service';
import { Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';

@Component({
  selector: 'app-not-found-page',
  template: `
  <ng-container *ngIf="!isProd">
    <header></header>
    <main>
      <h1>Oops !</h1>
      <p>
        Cette page n'est malheureusement pas disponible. Le lien que vous avez suivi n'est peut-être pas correct ou la
        page peut avoir été supprimée.
      </p>
      <section class="account-access">
        <p><strong>API disponibles&nbsp;:</strong></p>
        <ul>
          <li>
            <a href="http://localhost:4000/consumerCreditSimulator/2">Accéder au simulateur CACF</a>
          </li>
        </ul>
      </section>

      <section class="account-access">
        <p><strong>Accéder à mes comptes&nbsp;:</strong></p>
        <ul>
          <li>
            <a href="https://particuliers.secure.lcl.fr/outil/UAUT?from=/outil/UWHO/Accueil/">Particulier</a>
          </li>
          <li>
            <a href="https://particuliers.secure.lcl.fr/outil/UAUT?from=/outil/UWHO/&MARCHE=BP">Banque Privée</a>
          </li>
          <li>
            <a href="https://professionnels.secure.lcl.fr/outil/UAUT?from=/outil/UWHO/Accueil/">Pro ACCESS</a>
          </li>
          <li>
            <a href="https://espacepro.secure.lcl.fr/outil/IQEN/Authentication/indexRedirect">LCL Espace Pro</a>
          </li>
          <li>
            <a href="https://entreprises.secure.lcl.fr/outil/IQEN/Authentication/indexRedirect">Entreprises</a>
          </li>
        </ul>
      </section>
    </main>
  </ng-container>
  `,
  styleUrls: ['./page-not-found.component.scss'],
})
export class PageNotFoundComponent implements OnInit {

  readonly lclLogo: string = '/assets/images/lcl_logo_bleu_signature.svg';

  private isBrowser = false;

  get isProd(): boolean {
    return this.configService.get('PROD');
  }

  constructor(private readonly configService: ConfigService,
    @Inject(PLATFORM_ID) private platformId: string) {
      this.isBrowser = isPlatformBrowser(platformId);
    }


  ngOnInit(): void {
    if (this.isBrowser && this.isProd) {
      this.redirectToLCLPageNotFound();
    }
  }

  redirectToLCLPageNotFound(): void {
    const url: string = this.configService.get('LCL_PAGE_NOT_FOUND_URL'); 
    window.location.href = url;
  }
}
